import React from "react";

export default function Header() {
  return (
    <header>
      <nav className="header_menu">
        <ul>
          <li>
            <a href="https://twitter.com/sathishselvam_" target="_blank" rel="noreferrer">
              Twitter
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/sathishselvam/" target="_blank" rel="noreferrer">
              Linked-in
            </a>
          </li>
          <li>
            <a href="https://www.hackerrank.com/sathishselvamdev" target="_blank" rel="noreferrer">
              HackerRank
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
